import { PaginationParameters } from "../../api/Pagination";
import { AuditLogItem } from "../../types/auditLogTypes";
import { AppDispatch, RootState } from "../store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleRequest } from "../utils/handleRequest";
import { auditLogsApi } from "../../api/auditLogsApi";

export const fetchPaginatedAuditLogsThunk = createAsyncThunk<
    { items: AuditLogItem[]; totalCount: number } | null,
    PaginationParameters,
    { dispatch: AppDispatch; state: RootState}
>("auditLogs/fetchPaginatedAuditLogs", async (paginationParameters, { dispatch }) => { 
    const callResult = await handleRequest(
        dispatch,
        "indirect",
        () => auditLogsApi.getAuditLogs(paginationParameters)
    );
    if (!callResult.success() || !callResult.result) return null;

    return callResult.result;
});